import React from "react";
import { humanReadableDate } from "@greeter/util";
import { classNames } from "@greeter/util";

import css from "./GreeterEventCard.module.scss";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  LazyCoverImage,
} from "@greeter/matter";

export type GreeterEventCardProps = {
  width?: string | number;
  name: string;
  coverUrl: string;
  description: string;
  endsAt: Date;
};

export const GreeterEventCard: React.FC<GreeterEventCardProps> = ({
  width,
  name,
  coverUrl,
  endsAt,
}) => {
  const style: any = {};
  if (width) style.width = width;

  return (
    <Card {...classNames(css.Card, css.GreeterEventCard)} style={style}>
      <CardHeader style={{ aspectRatio: "16 / 7" }}>
        <LazyCoverImage src={coverUrl} />
      </CardHeader>
      <CardContent className={css.cardContent}>
        <CardTitle>{name}</CardTitle>
        <CardDescription>{humanReadableDate(endsAt)}</CardDescription>
      </CardContent>
    </Card>
  );
};
